import { render } from "./ProjectRewardsContent.vue?vue&type=template&id=39798b8c"
import script from "./ProjectRewardsContent.vue?vue&type=script&lang=js"
export * from "./ProjectRewardsContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__